<kodit-dropdown
  [formCtrlId]="formCtrlId"
  [options]="items"
  ctrlTooltip="Tip obrasca"
  ctrlTooltipPosition="top"
  [formCtrl]="formCtrl"
></kodit-dropdown>